<p-toast></p-toast>
<div *ngIf="blocked" class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="{{lbl_loading}}" class="loading-image" />
    <span style="color: white; font-size: large;">{{lbl_loading}}</span>  
</div>
<div class="card">
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{lbl_go_Back}}" icon="pi pi-chevron-left" class="p-button-warning p-mr-2"
                (click)="redirectWorkShop()"></button>

        </ng-template>

    </p-toolbar>


    <div class="p-grid">
        <div class="p-col-12 p-md-6">
            <p-panel>
                <div class="p-d-flex p-ai-center p-jc-between p-py-1">
                    <span>{{lbl_church_name}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null ?
                        workShopDetail.chr.name : ""}}</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_workshop}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null?
                        workShopDetail.wst.wsName : ""}} </span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_schedule}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.f0 != null?
                        workShopDetail.f0.fromTime : ""}} -
                        {{workShopDetail != null && workShopDetail.f0 != null ? workShopDetail.f0.toTime : ""}}</span>
                </div>
                <!--div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_part1}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.partN15s != null ? workShopDetail.partN15s : "0"}}	</span>
                </div>
                <div class="p-d-flex p-ai-center p-jc-between p-pt-1 p-py-1">
                    <span>{{lbl_part2}}</span>
                    <span class="p-text-bold">{{workShopDetail != null && workShopDetail.partN2s != null ? workShopDetail.partN2s : "0"}}	</span>
                </div-->

            </p-panel>
        </div>
    </div>

    <p-table #dt [value]="listParticipant" [rows]="10" [paginator]="true"
        [globalFilterFields]="['name','mobPhon','email','gender']" [(selection)]="selectedParticipant" [rowHover]="true"
        dataKey="particiId" currentPageReportTemplate="{{lbl_showing}} {first} {{lbl_of}} {last} {{lbl_records}}"
        [showCurrentPageReport]="true" responsive="true">
        <ng-template pTemplate="caption">
            <div class="p-d-flex p-ai-center p-jc-between">
                <h5 class="p-m-0">{{lbl_participants}}</h5>
                <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="{{lbl_search}}..." />
                </span>
            </div>
            <span class="p-input-icon-left">
                <button type="button" pButton pRipple icon="pi pi-plus" (click)="redirectParticipantDetail(null)"
                    class="p-mr-4 z-5" pTooltip="{{lbl_new_record}}" tooltipPosition="bottom"
                    [disabled]="workShopDetail != null && workShopDetail.f0 != null &&  (workShopDetail.f0.status == 'P' || workShopDetail.f0.status == 'A') ? false : true "></button>

                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success p-mr-2 z-5" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning p-mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </span>
        </ng-template>
        <ng-template pTemplate="header">
            <tr>

                <th pSortableColumn="name">{{lbl_name}} <p-sortIcon field="name"></p-sortIcon></th>
                <th pSortableColumn="mobPhon">{{lbl_cell_phone}} <p-sortIcon field="mobPhon"></p-sortIcon></th>
                <th pSortableColumn="email">{{lbl_email}} <p-sortIcon field="email"></p-sortIcon></th>
                <th pSortableColumn="gender">{{lbl_gender}} <p-sortIcon field="gender"></p-sortIcon></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-participant>
            <tr>

                <td>{{participant.name}} {{participant.lastName}}</td>
                <td>{{participant.mobPhon}} </td>
                <td style="white-space: normal; word-wrap: break-word;">{{participant.email}}</td>
                <td>{{participant.gender}}</td>

                <td>
                    <button pButton pRipple icon="pi pi-pencil" class="p-button-rounded p-button-warning p-mr-2"
                        (click)="redirectParticipantDetail(participant)" pTooltip="{{lbl_edit}}"
                        [disabled]="canEdit()"></button>
                    <button pButton pRipple icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        (click)="deleteParticipant(participant)" pTooltip="{{lbl_delete}}"
                        [disabled]="canEdit()"></button>
                </td>
            </tr>
        </ng-template>
        <ng-template pTemplate="summary">
            <div class="p-d-flex p-ai-center p-jc-between">
                {{lbl_total}} {{listParticipant ? listParticipant.length : 0 }} {{lbl_participants}}.
            </div>
        </ng-template>
    </p-table>
</div>

<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!--app-partipant-form0></app-partipant-form0-->